export const ROLES = {
  MANAGER: 'MANAGER',
  EMPLOYEE: 'EMPLOYEE',
}
